function isIosWebKit() {
    if (void 0 === globalThis.window) return false;
    const ua = globalThis.navigator?.userAgent;
    return /iPhone/i.test(ua) && /WebKit/i.test(ua);
}
function createHiddenInput() {
    const el = document.createElement('input');
    el.setAttribute('type', 'text');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('tabindex', '-1');
    el.style.position = 'absolute';
    el.style.height = '0';
    el.style.opacity = '0';
    el.style.fontSize = '16px';
    return el;
}
function beginIosKeyboardRelay(anchor) {
    if (!isIosWebKit() || !anchor) return (realInput)=>realInput?.focus();
    const fakeInput = createHiddenInput();
    anchor.appendChild(fakeInput);
    fakeInput.focus();
    return (realInput)=>{
        realInput?.focus();
        fakeInput.remove();
    };
}
export { beginIosKeyboardRelay };
